import SingleStackTag from '../SingleStackTag';

interface IStackTagsProps {
  stacks: string[];
  className?: string;
}

const StackTags: React.FC<IStackTagsProps> = ({ stacks, className = '' }) => {
  return (
    <>
      {stacks.map((stack, index) => (
        <SingleStackTag
          key={`${stack}-${index}`}
          stack={stack}
          className={className}
        />
      ))}
    </>
  );
};

export default StackTags;
